import { render, staticRenderFns } from "./RipaFormStep5.vue?vue&type=template&id=5c0e3c85"
import script from "./RipaFormStep5.vue?vue&type=script&lang=js"
export * from "./RipaFormStep5.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports